import React from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import YeloLogo from 'app/components/Icons/YeloLogo';
import { container, header, line, mainText, secondaryText } from 'app/pages/InProgressPage/InProgressPage.sx';
import useInProgressPage from 'app/pages/InProgressPage/useInProgressPage';
import LargeLoadingIcon from "app/components/Icons/LargeLoadingIcon";
import {NavLink} from "react-router-dom";

const InProgressPage = () => {
  const { homePagaHandler } = useInProgressPage();

  return (
    <Box sx={container}>
      <Box sx={line}></Box>
      <Box sx={header}>
          <NavLink to={`/az/home-page`}>
                <YeloLogo />
          </NavLink>
      </Box>
      <Divider sx={{ width: '100%' }} />
      <LargeLoadingIcon sx={{ mt: '49px' }} />
      <Typography sx={mainText}>Komandamız bu bölmə üzərində yeniləmə işləri aparır</Typography>
      <Typography sx={secondaryText}>
          Yaxın zamanda sizin üçün əlçatan olacaq
      </Typography>
      <Button onClick={homePagaHandler} sx={{ mt: '24px' }}>
        Ana səhifə
      </Button>
    </Box>
  );
};

export default InProgressPage;
